import React from 'react';
import FreelancerUserService from '../../../Services/FreelancerUserService';
import AuthService from '../../../Services/authService';
import PaymentInformationForChile from './EditWindowTabs/PaymentInformationForChile';
import PaymentInformationForBrazil from './EditWindowTabs/PaymentInformationForBrazil';
import PaymentInformationForChina from './EditWindowTabs/PaymentInformationForChina';
import PaymentInformationForEurope from './EditWindowTabs/PaymentInformationForEurope';
import PaymentInformationForIndia from './EditWindowTabs/PaymentInformationForIndia';
import PaymentInformationForSingapore from './EditWindowTabs/PaymentInformationForSingapore';
import PaymentInformationForUSA from './EditWindowTabs/PaymentInformationForUSA';
import GeneralData from './EditWindowTabs/GeneralData';
import EmploymentInformation from './EditWindowTabs/EmploymentInformation';
import FreelancerUserEditItem from '../../../Domain/FreelancerUserEditItem';
import PaymentInformationForMexico from './EditWindowTabs/PaymentInformationForMexico';
import PaymentInformationForDubai from './EditWindowTabs/PaymentInformationForDubai';

export default class EditFreelancerUserWindowDescription {
  static titleForCreate = 'Create New Vendor';

  static titleForEdit = (editItem) =>
    'Edit Vendor Information (' +
    editItem.FirstName +
    ' ' +
    editItem.LastName +
    ' - ' +
    editItem.FreelancerUserId +
    ')';

  static itemType = FreelancerUserEditItem;

  static serviceFunction = (edited) =>
    edited.FreelancerUserId
      ? FreelancerUserService.EditFreelancerUser(edited)
      : FreelancerUserService.AddNewFreelancerUser(edited);

  static finishButtonLabel = 'Save Vendor';

  static messageOnSuccess = (edited) => {
    if (edited.FreelancerUserId) {
      return 'Item has been saved.';
    }

    return `
      <p>
        The new vendor has been created with an inactive status. Please note that only HR has the authority to change
        the status to active. You cannot add any line items to a vendor, and fees cannot be created while the vendor is
        inactive.
        <br />
        <br />
        Please open an IT Onboarding ticket and notify your HR department.
      </p>
    `;
  };

  static approveBeforeSaveCheck = (edited) => {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();

    if (
      edited.OriginalIsActive === false &&
      edited.IsActive === true &&
      !loggedInUser.roles.includes('VendorHr') &&
      !loggedInUser.roles.includes('Admin')
    ) {
      return 'Be aware that only the HR is able to reactivate a user. Do you want to continue?';
    }
  };

  static pagesInGeneralEditWizzard = [
    GeneralData.returnDescriptionTab(),
    EmploymentInformation.returnDescriptionTab(),
    PaymentInformationForUSA.returnDescriptionTab(),
    PaymentInformationForEurope.returnDescriptionTab(),
    PaymentInformationForBrazil.returnDescriptionTab(),
    PaymentInformationForIndia.returnDescriptionTab(),
    PaymentInformationForChina.returnDescriptionTab(),
    PaymentInformationForChile.returnDescriptionTab(),
    PaymentInformationForSingapore.returnDescriptionTab(),
    PaymentInformationForMexico.returnDescriptionTab(),
    PaymentInformationForDubai.returnDescriptionTab(),
  ];
}
